module.exports = __webpack_public_path__ + "static/4-f44aab2bf37e3fd8e43100f096886f81.jpg";